import {Injectable} from '@angular/core';
import {Observable, Subject, BehaviorSubject} from 'rxjs';
import {MyHistoryItem} from '../resource/history';
import {APPCONFIG} from '../config';
import {environment} from '../../environments/environment';
import {defaultEndpointKind} from '../core/deployment';
import {Endpoint} from './endpoint';

@Injectable()
export class LayoutService {
  private loadingStateSource: Subject<string> = new BehaviorSubject<string>('startup');

  private preloaderStateSource: Subject<string> = new Subject<string>();

  private resourceViewUpdateSource: Subject<MyHistoryItem> = new Subject<MyHistoryItem>();

  private themeStateSource: Subject<boolean> = new Subject<boolean>();

  private endpointSource: Subject<Endpoint> = new BehaviorSubject<Endpoint>(
    new Endpoint(defaultEndpointKind(), environment.ServerApiUrl, 'Default'),
  );

  preloaderState$ = this.preloaderStateSource.asObservable();

  loadingState$ = this.loadingStateSource.asObservable();

  resourceViewUpdate$ = this.resourceViewUpdateSource.asObservable();

  themeState$: Observable<boolean> = this.themeStateSource.asObservable();

  endpoint$: Observable<Endpoint> = this.endpointSource.asObservable();

  private loadProcesses = 0;

  updatePreloaderState(state: string) {
    if (state === 'hide-all') {
      this.loadProcesses = 0;
    } else if (state === 'active') {
      this.loadProcesses++;
    } else {
      this.loadProcesses--;
      if (this.loadProcesses < 0) this.loadProcesses = 0;
    }
    if (this.loadProcesses > 0) {
      this.preloaderStateSource.next('active');
    } else if (this.loadProcesses <= 0) {
      this.preloaderStateSource.next('hide');
    }
  }

  updateLoadingState(state: string) {
    this.loadingStateSource.next(state);
  }

  updateDarkMode(darkMode: boolean) {
    this.themeStateSource.next(darkMode);
  }

  updateEndpoint(endpoint: Endpoint) {
    this.endpointSource.next(endpoint);
  }

  updateResourceView(siteType: string, id: string, id2: string) {
    this.resourceViewUpdateSource.next(new MyHistoryItem(siteType, id, id2, null));
  }
}
